const MicroscopicResultInWord = ["RARE", "FEW", "MODERATE", "PLENTY"];

export default MicroscopicResultInWord;
